module.exports = __webpack_public_path__ + "static/media/helhet.39595592.mp3";